/**
 * ClientId enum is used to identify the client that is making the request,
 * where "client" refers to the repo where the client is built from.
 *
 * This means that every repo should have its own id,
 * even if the application built from the repo is virtually the same as another application.
 */
export var ClientId;
(function (ClientId) {
    ClientId[ClientId["NCWeb"] = 1] = "NCWeb";
    ClientId[ClientId["WebSignup"] = 2] = "WebSignup";
    ClientId[ClientId["NCApp3"] = 3] = "NCApp3";
    ClientId[ClientId["Admin3"] = 4] = "Admin3";
    ClientId[ClientId["NCClearblue"] = 5] = "NCClearblue";
    ClientId[ClientId["NCWebMeta"] = 6] = "NCWebMeta";
})(ClientId || (ClientId = {}));
